import type { Query } from '@ab-core/graphql/dist';
import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { getErrorLoggerFunction } from '../utils';
import { GET_CONTACTS_WITHOUT_RIGHTS } from './gql/getContactsWithoutRights';

type QueryDataType = Pick<Query, 'getContactsWithoutRights'>;
type OutgoingDataType = QueryDataType['getContactsWithoutRights'];

const onError = getErrorLoggerFunction('getContactsWithoutRights');

export const useGetContactsWithoutRights = () => {
    const [outgoingData, setOutgoingData] = useState<OutgoingDataType>(undefined);

    const { data, loading, refetch, error } = useQuery<QueryDataType>(GET_CONTACTS_WITHOUT_RIGHTS, {
        onError
    });

    useEffect(() => {
        if (data) {
            setOutgoingData(data.getContactsWithoutRights);
        }
    }, [data]);

    return {
        contactsWithoutRights: outgoingData,
        error: !!error,
        success: !!data,
        loading,
        refetch
    };
};
